import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "batch-move"
};
const _hoisted_2 = {
  class: "move-check-select"
};
const _hoisted_3 = {
  class: "batch-operation-table"
};
const _hoisted_4 = {
  class: "btn-group"
};
import { toRefs, ref, computed, onMounted, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { queryComponent, refreshstructure, batchMoveServer, getZoneList } from '@/api/management/batchOperation';
import { useUserDefaultSettingStore } from '@/store/user';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'batch-move-dialog',
  props: {
    visible: {
      type: Boolean
    },
    checkIdList: {},
    checkInfo: {}
  },
  emits: ["confirm", "update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      userName
    } = storeToRefs(userDefaultSettingStore);
    const props = __props;
    const {
      visible,
      checkIdList,
      checkInfo
    } = toRefs(props);
    const tableData = ref([]);
    const initTable = async () => {
      const ids = checkIdList.value.join('_');
      const {
        ServerList
      } = await queryComponent(ids, 0, 0);
      tableData.value = ServerList;
    };
    const computedTableData = computed(() => tableData.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const movingZoneList = ref([]);
    const initZoneOptions = async () => {
      const {
        zoneList
      } = await getZoneList(checkInfo.value.zoneId, checkInfo.value.clusterId);
      movingZoneList.value = zoneList.filter(zone => Number(zone.zoneId) !== Number(checkInfo.value.zoneId));
    };
    const targetZone = ref();
    const handleMove = async () => {
      if ((targetZone.value ?? '') === '') {
        ElMessage({
          type: 'info',
          message: 'Please select a zone'
        });
        return;
      }
      ElMessageBox.prompt('Are you sure to move these Checks to Zone()? Please input reason.', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        inputPattern: /^[a-zA-Z0-9\s\-._~!$&'()*+,;=:@]+$/,
        inputErrorMessage: 'Invalid Reason'
      }).then(({
        value
      }) => {
        moveChecks(value);
      });
    };
    const moveChecks = async reason => {
      await refreshstructure();
      ElMessage({
        type: 'success',
        message: 'Moving check...'
      });
      const ids = checkIdList.value.join('_');
      await batchMoveServer(ids, targetZone.value, userName.value, reason);
      ElMessage({
        type: 'success',
        message: 'Success'
      });
      emits('update:visible', false);
    };
    const emits = __emit;
    const dialogVisible = ref(false);
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    const handleCancel = () => {
      emits('update:visible', false);
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (dialogVisible.value) {
        initTable();
        initZoneOptions();
      }
    });
    return (_ctx, _cache) => {
      const _component_dialog_header = _resolveComponent("dialog-header");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "60%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(_component_dialog_header, {
          onClose: close,
          "header-name": "Batch Move Checks",
          "guide-link": "aaa"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "Move checks to", -1)), _createVNode(_component_el_select, {
          filterable: "",
          modelValue: targetZone.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => targetZone.value = $event),
          placeholder: "Please select zone"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movingZoneList.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              label: item.zoneName,
              value: item.zoneId,
              key: item.zoneId
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
          data: computedTableData.value,
          style: {
            "width": "99%"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "index",
            index: index => index + 1
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "clusterName",
            label: "Cluster"
          }), _createVNode(_component_el_table_column, {
            prop: "zoneName",
            label: "Zone"
          }), _createVNode(_component_el_table_column, {
            prop: "serverIp",
            label: "Check"
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
          "page-sizes": [10, 20, 50],
          layout: "total, sizes, prev, pager, next",
          class: "batch-operation-pagination mt-10",
          total: itemNumber.value
        }, null, 8, ["current-page", "page-size", "total"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          plain: "",
          onClick: handleCancel
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("Cancel")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleMove
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("Move")])),
          _: 1
        })])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});